module.exports = false;



//////////////////
// WEBPACK FOOTER
// /tmp/build_310c34ba/node_modules/core-js/internals/is-pure.js
// module id = 24
// module chunks = 2